import ProductsLoading from "./ProductsLoading";
import Product from "./Product";
import ProductsHeader from "./ProductsHeader";
import React, {useContext} from "react";
import {WooContext} from "../WooContext";

function Products({products}) {
    const {pagedState, acctCustomer, hireOrSaleState} = useContext(WooContext);
    const [paged] = pagedState;
    const [hireOrSale] = hireOrSaleState;
    return (
        <div className="products-container">
            <ProductsHeader products={products}/>
            <ul className="products">
                {products.loading === true ?
                    <ProductsLoading size={paged.size||null}/>:
                    products.data && products.data.products.nodes.length ? products.data.products.nodes.map((product, index) => (
                    <Product key={index} acctCustomer={acctCustomer} hireOrSale={hireOrSale} product={product} />
                    )) : <li className="no-results">No results match your criteria, please try again with different criteria</li>
                }

            </ul>
        </div>
    )
}

export default Products;